import React from "react";
import useSWR from "swr";
import Select from "./atoms/Select";

/**
 * 승인자 후보 셀렉트 — type 별 승인 자격자(level)만 서버가 필터해 내려준다.
 * (지점 변경 / 상담일지 등록요청 등 여러 폼에서 공용)
 */
function ApproverSelect({ type, value, onChange }) {
  const { data } = useSWR(`/manager/change-request/approvers?type=${type}`);
  const list = Array.isArray(data) ? data : [];
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={!list.length}
    >
      <option value="">
        {data == null
          ? "불러오는 중..."
          : list.length
          ? "승인자를 선택해주세요"
          : "지정 가능한 승인자가 없습니다"}
      </option>
      {list.map((u) => (
        <option key={u.id} value={u.id}>
          {u.name}
          {u.position ? ` (${u.position})` : ""}
        </option>
      ))}
    </Select>
  );
}

export default ApproverSelect;
